import { forwardRef } from 'react';

import {
  BaseCheckerInput,
  type BaseCheckerInputProps,
} from '@/domains/core/tamagoshi/CheckerInput/BaseCheckerInput';

import styles from './Radio.module.scss';

export interface RadioProps extends BaseCheckerInputProps {
  name?: string;
}

export const Radio = forwardRef<HTMLInputElement, RadioProps>((props, ref) => (
  <BaseCheckerInput
    {...props}
    type="radio"
    ref={ref}
    rootClassName={styles.radio}
    labelClassName={styles.label}
    inputClassName={styles.input}
  />
));

Radio.displayName = 'Radio';
